<template>
	<div class="flex items-center gap-2">
		<div
			v-tooltip="{ content: 'Increase Indent', placement: 'bottom' }"
			class="flex-center size-6 cursor-pointer rounded bg-won-sand-light hover:bg-won-gray-light"
		>
			<IncreaseIndentation
				@click="sinkListItem"
			/>
		</div>

		<div
			v-tooltip="{ content: 'Decrease Indent', placement: 'bottom' }"
			class="flex-center size-6 cursor-pointer rounded bg-won-sand-light hover:bg-won-gray-light"
		>
			<DecreaseIndentation
				@click="liftListItem"
			/>
		</div>

		<div
			v-tooltip="{ content: 'Bulleted List', placement: 'bottom' }"
			class="flex-center size-6 cursor-pointer gap-1 rounded bg-won-sand-light hover:bg-won-gray-light"
		>
			<BulletPointsIcon
				@click="bulletListHandler"
			/>
		</div>
	</div>
</template>

<script setup>
import { toRefs } from 'vue';
import { NodePos } from '@tiptap/vue-3';
import { useTiptapStore } from '../../store/tiptap.store';


import IncreaseIndentation from '../../icons/increase-indentation.vue';
import DecreaseIndentation from '../../icons/decrease-indentation.vue';
import BulletPointsIcon from '../../icons/bullet-list-icon.vue';

const tiptapStore = useTiptapStore();
const { editor } = toRefs(tiptapStore);

const bulletListHandler = () => {
	editor.value.commands.resetIndentation();
	editor.value.chain().focus().toggleBulletList().run();
};

const sinkListItem = () => {
	const nodePos = new NodePos(editor.value.state.selection.$anchor, editor.value);
	const result = nodePos.closest('bulletList');

	if (result == null) {
		editor.value.chain().focus().indent().run();
	} else {
		editor.value.chain().focus().sinkListItem('listItem').run();
	}
};

const liftListItem = () => {
	const nodePos = new NodePos(editor.value.state.selection.$anchor, editor.value);
	const result = nodePos.closest('bulletList');

	if (result == null) {
		editor.value.chain().focus().outdent().run();
	} else {
		editor.value.chain().focus().liftListItem('listItem').run();
	}
};
</script>
